import PropTypes from 'prop-types';
import React, { Component } from 'react';
import drawRangeChart from './d3RangeChartEnhanced';
import { currencyFormatter } from '../Modules/JobRanges/Utils/Utils';
import './RangeChartEnhanced.scss';
const rangeChartHeight = 81.59;
const rangeChartWidth = 700;

export default class RangeChartEnhanced extends Component {
  static propTypes = {
    data: PropTypes.object,
    loading: PropTypes.bool,
    reportMode: PropTypes.string, // pass in 'print' to always show the labels
    id: PropTypes.string.isRequired,
    scale: PropTypes.object,
    scatterData: PropTypes.array,
    currencyFormatter: PropTypes.func,
    animate: PropTypes.bool,
    tooltipFormatter: PropTypes.func,
    toolTipWidth: PropTypes.number,
    colorOverrides: PropTypes.array,
    fill: PropTypes.string,
    stroke: PropTypes.string,
    width: PropTypes.number,
    incompleteData: PropTypes.bool,
    scatterHoverHandler: PropTypes.func,
    scatterHoverHandlerOut: PropTypes.func,
    scatterClickHandler: PropTypes.func,
    noDataText: PropTypes.string
  };

  static defaultProps = {
    noDataText: 'No Data',
    loading: false,
    scatterData: [],
    currencyFormatter: (val, name) => {
      return currencyFormatter(val, { roundToNearest: 1000 });
    },
    animate: true,
    tooltipFormatter: (point, position) => {},
    toolTipWidth: 155
  };

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.update();
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (
      !this.props.data ||
      this.props.incompleteData !== nextProps.incompleteData ||
      this.props.loading !== nextProps.loading ||
      this.props.currencyFormatter !== nextProps.currencyFormatter ||
      this.props.genderToggle !== nextProps.genderToggle
    )
      return true;
    const dataKeys = Object.keys(this.props.data);
    for (let i = 0; i < dataKeys.length; i++) {
      if (this.props.data[dataKeys[i]] !== nextProps.data[dataKeys[i]]) return true;
    }
    return false;
  }

  componentDidUpdate(prevProps, prevState) {
    this.update();
  }

  update() {
    let { data, incompleteData, scatterClickHandler, genderToggle} = this.props; // eslint-disable-line prefer-const

    if (!this.isValidChartData(data, incompleteData)) return;

    const additionalChartData = {
      width: this.props.width || rangeChartWidth,
      height: rangeChartHeight,
      barHeight: 20,
      labelFontSizeBottom: 14,
      labelFontSizeTop: 12,
      labelToBarSpacingBottom: 20,
      labelToBarSpacingTop: 10,
      labelToLabelMinSpacing: 90,
      centerLineWidth: 0.005,
      circleRadius: 5,
      circleStrokeWidth: 2,
      colorOverrides: this.props.colorOverrides,
      fill: this.props.fill,
      stroke: this.props.stroke,
      toolTipToBarSpacing: 100
    };
    // All properties are REQUIRED!
    let chartData = {
      data: { ...data },
      ...additionalChartData,
      toolTipWidth: this.props.toolTipWidth,
      svgId: this.props.id,
      containerId: this.props.id + '-d3-container',
      reportMode: this.props.reportMode,
      tooltipFormatter: this.props.tooltipFormatter,
      animate: this.props.animate,
      scale: this.props.scale,
      scatterData: this.props.scatterData,
      scatterHoverHandler: this.props.scatterHoverHandler,
      scatterHoverHandlerOut: this.props.scatterHoverHandlerOut
    };

    try {
      drawRangeChart(chartData, scatterClickHandler, this.props.currencyFormatter, genderToggle);
    } catch (err) {
      console.log('error drawing enhanced range chart: ', err);
    }
  }

  isValidChartData(data, incompleteData) {
    return data && data['50th'] && !data.incompleteData && !incompleteData;
  }

  render() {
    const { data, incompleteData, loading, noDataText } = this.props;
    if ((data && data.incompleteData) || incompleteData) {
      return (
        <div className="jobDetails__emptyChart--container" id={this.props.id + '-' + 'd3-container'}>
          <div className="jobDetails__emptyChart--container">
            <span className="jobDetails__emptyChart--text">{noDataText}</span>
            <img
              className="jobDetails--emptyChart"
              src="/view/static/lab/imgs/chartPlaceholders/empty_price_chart.svg"
            />
          </div>
        </div>
      );
    }

    const isValidChartData = this.isValidChartData(data, incompleteData);

    if (loading)
      return (
        <div className="rangeChart-loading-container">
          <span className="rangeChart-loading-inner">
            Loading Range Chart <i className="icon-animate-spin icon-spin table-indicator" />
          </span>
        </div>
      );
    return (
      <div
        className={`jobDetails__rangeChart--overflow${isValidChartData ? ' visible' : ''}`}
        id={this.props.id + '-' + 'd3-container'}
      >
        <svg id={this.props.id} height={rangeChartHeight} width={this.props.width || rangeChartWidth} />
        <div className="d3Tooltip" />
      </div>
    );
  }
}
